/**
 * Kanonischer Name des KI-Assistenten — Icarus D&D Design: „Dädalus"
 * (im Mythos der gute Ratgeber, den Ikarus ignorierte).
 *
 * Zentrale Konstante statt verstreuter String-Fallbacks. Ein per Profil
 * gespeicherter eigener Name (`profiles.assistant_name`) gewinnt weiter —
 * ausgenommen der Legacy-Wert „Nutri", der auf den neuen Markennamen
 * migriert wird, damit Bestandsprofile nicht auf dem alten Namen
 * hängenbleiben.
 */
export const ASSISTANT_NAME = 'Dädalus';

export function resolveAssistantName(stored?: string | null): string {
  if (!stored || stored === 'Nutri') return ASSISTANT_NAME;
  return stored;
}
